import React from 'react';
import { Box, Theme } from 'theme-ui';

export type CustomTheme = Omit<Theme, 'palette'>;

export type {
  AlertProps,
  AspectImageProps,
  AspectRatioProps,
  AvatarProps,
  BadgeProps,
  BoxOwnProps,
  BoxProps,
  ButtonProps,
  CSSObject,
  CSSProperties,
  CSSPseudoSelectorProps,
  CardProps,
  CheckboxProps,
  CloseProps,
  ColorMode,
  ColorModesScale,
  ContainerProps,
  DividerProps,
  DonutProps,
  EmbedProps,
  Field,
  FieldOwnProps,
  FieldProps,
  FlexOwnProps,
  FlexProps,
  GridProps,
  HeadingProps,
  IconButtonProps,
  ImageProps,
  InputProps,
  LabelProps,
  LinkProps,
  MenuButtonProps,
  MessageProps,
  NavLinkProps,
  ParagraphProps,
  ProgressProps,
  RadioProps,
  ResponsiveStyleValue,
  SelectProps,
  SliderProps,
  SpinnerProps,
  StylePropertyValue,
  SwitchProps,
  SxProp,
  TLengthStyledSystem,
  TextProps,
  TextareaProps,
  Theme,
  ThemeStyles,
  ThemeUICSSObject,
  ThemeUICSSProperties,
  ThemeUIContextValue,
  ThemeUIStyleObject,
} from 'theme-ui';

export {
  Alert,
  AspectImage,
  AspectRatio,
  Avatar,
  Badge,
  BaseStyles,
  Box,
  Button,
  Card,
  Checkbox,
  Close,
  CloseIcon,
  Container,
  Divider,
  Donut,
  Embed,
  Flex,
  Global,
  Grid,
  Heading,
  IconButton,
  Image,
  InitializeColorMode,
  Input,
  Label,
  Link,
  MenuButton,
  MenuIcon,
  Message,
  NavLink,
  Paragraph,
  Progress,
  Radio,
  Select,
  Slider,
  Spinner,
  Switch,
  Text,
  Textarea,
  createElement,
  css,
  get,
  merge,
  useColorMode,
  useThemeUI,
} from 'theme-ui';
//

export const Form = (
  props: React.ClassAttributes<HTMLFormElement> &
    React.FormHTMLAttributes<HTMLFormElement>,
) => <Box as="form" {...(props as any)} />;
